<template>
    <div>
      <div :style="style">
        <el-input @blur="saveCell" v-model="actual_value" width="100%" ></el-input>
      </div>
    </div>
</template>

<script>
    export default {
        name: "TableCustomEditableCell",
        props: ['value','row_label','cell_label','category_field_set_id','extent_id'],
        data() {
          return {
            actual_value: [],
            status: null,
          }
        },
        mounted() {
            this.actual_value = this.value
        },
        watch: {
          value: function () {
            this.actual_value = this.value
          },
        },
        computed: {
          style: function () {
            if (this.status==='error') {
              return 'border: solid red'
            } else if (this.status==='saving') {
              return 'border-left: solid lightblue '
            } else {
              return ''
            }
          },
        },
        methods: {
            saveCell() {
              this.status = 'saving'
              axios.post('/api/category/by_values/' + this.extent_id, {
                row_label: this.row_label,
                cell_label: this.cell_label,
                category_field_set_id: this.category_field_set_id,
                value: this.actual_value
              }).then(response => {
                console.log(response)
                console.log('finished saving cell')
                this.status = null
              }).catch(error => {
                this.status = 'error'
                let message = ''
                if (error.response.data.hasOwnProperty('message')) {
                  message = 'Technical error: ' + error.response.data.message
                }
                this.$message.error('Could not save cell. Trying refreshing the page (you may have been logged out after inactivity). ' + message);
                console.log('Could not save cell')
                console.log(error.response)
              });
            }
        }
    }
</script>

<style scoped>

</style>